import * as React from "react";

import { noop } from "../../../../../Common/TypingUtils";
import { AbsoluteModelPath } from "../../../../../Common/ModelPath/ModelPath";

export interface IFocusRequestsSource {
    addRequestFocusListener(onFocus: (path?: unknown) => void): void;
    removeRequestFocusListener(onFocus: () => void): void;
    addRequestPathAvailabilityListener(listener: (path: AbsoluteModelPath) => Promise<void>): void;
    removeRequestPathAvailabilityListener(listener: (path: AbsoluteModelPath) => Promise<void>): void;
}

const emptyFocusRequestsSource = {
    addRequestFocusListener: noop,
    removeRequestFocusListener: noop,
    addRequestPathAvailabilityListener: noop,
    removeRequestPathAvailabilityListener: noop,
};

export const FocusRequestsSourceContext = React.createContext<IFocusRequestsSource>(emptyFocusRequestsSource);
